import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { CalculationMethodType } from "__generated__/graphql";
import { ApplicableAgreementForm } from "view/calculationmethods/types/calculationmethod";
import { AgreementFormInput } from "view/agreements/validation/agreement.zod";

const ApplicableAgreementsSelect = <Multiple extends boolean = false,>({
	agreements,
	value,
	onChange,
	multiple,
	getOptionDisabled,
}: Omit<SelectProps<ApplicableAgreementForm, Multiple>, "fetchOptions"> & {
	agreements: AgreementFormInput[]
}) => {
	const fetchOptions = (_inputValue: string): ApplicableAgreementForm[] => agreements.filter((x) => x.calculationMethod?.type !== CalculationMethodType.PercentageOnAgreements);

	const getOptionLabel = (option: ApplicableAgreementForm) => {
		const index = agreements.findIndex(x => option.id === x.id || option.uuid === x.uuid);
		if (option.id) {
			return `${intl.formatMessage({ id: `AGREEMENT_TYPE_${option.type}` })} (#${index + 1})`;
		}
		if (option.type) {
			return `${intl.formatMessage({ id: `AGREEMENT_TYPE_${option.type}` })} (${intl.formatMessage({ id: "NEW" })} - #${index + 1})`;
		}
		return "";
	};

	return <Select
		getOptionDisabled={getOptionDisabled}
		multiple={multiple}
		fetchOptions={fetchOptions}
		getOptionLabel={(option) => getOptionLabel(option)}
		value={value}
		onChange={onChange}
	/>;
};

export default ApplicableAgreementsSelect;
